// extracted by mini-css-extract-plugin
export default {"search-container":"Kw7my","wrapper-section":"jkZZm","wrapper-section__fixed-bottom":"hGqPS"};